module.exports = __webpack_public_path__ + "static/media/administration.9449e6b7.svg";